import { applyMiddleware, createStore, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from 'src/reducers';
import { createLogger } from 'redux-logger';

export default function configureStore(preloadedState = {}) {
  const logger = createLogger({
    predicate: () => process.env.NODE_ENV === 'development'
  });
  const middlewares = [thunkMiddleware, logger];
  const middlewareEnhancer = composeWithDevTools(
    applyMiddleware(...middlewares)
  );

  const enhancers = [middlewareEnhancer];
  const composedEnhancers = compose(...enhancers);

  const storedState = JSON.parse(localStorage.getItem('state'));
  if (storedState && storedState.user) {
    preloadedState.session = storedState;
  }

  const store = createStore(rootReducer, preloadedState, composedEnhancers);

  return store;
}
